// Zone2.js
import React from 'react';
import museumImg from '../ZonetablePoster/Museum.png'; 
import '../ZonetablePoster/allzones.css';

const videoLinks = [
  { title: "The PRUTL TIME-STORM (Hindi)", link: "https://youtu.be/vKeaqGHzE28" },
  { title: "The PRUTL TIME-STORM (English)", link: "https://youtu.be/UmdqCtlH_6k" },
  { title: "When Hearts Whisper Again (Hindi)", link: "https://youtu.be/NXDQ2FwcO2Q" },
  { title: "When Hearts Whisper Again (English)", link: "https://youtu.be/cv0jc-otBJQ" },
  { title: "EMI-e-motion (Hindi)", link: "https://youtu.be/6-nYSzmS6Nk" },
  { title: "EMI-e-motion (English)", link: "https://youtu.be/2Au7emORZpA" },
  { title: "The Last Bus to Kailash (Hindi)", link: "https://youtu.be/hdcT_i7ThFM" },
  { title: "The Last Bus to Kailash (English)", link: "https://youtu.be/wduHjjqTLBI" },
  { title: "THE MIRROR OF ERIS (Hindi)", link: "https://youtu.be/I2qMGKVhnxY" },
  { title: "THE MIRROR OF ERIS (English)", link: "https://youtu.be/8K001vHMJuA" }
];

const tableData = [
  {
    picture: museumImg,
    title: "A Museum Love Story",
    genre: "Romance • Self-Discovery • Faith • Family"
  }
];


function Zone2() {
 return (
    <div style={{ backgroundColor: 'black', minHeight: '100vh', padding: '20px' }}>
      <h1 className="zone-title">Zone 2</h1>

      <table className="zone-table">
        <thead>
          <tr>
            <th>Museo Series</th>
            <th>Title</th>
            <th>Genre</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, idx) => (
            <tr key={idx}>
              <td><img src={item.picture} alt={item.title} /></td>
              <td className="title">{item.title}</td>
              <td className="genre">{item.genre}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Videos Grid */}
      <div className="episodes-grid" style={{ marginTop: '40px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
        {videoLinks.map((video, index) => (
          <div key={index} className="episode-card" style={{ backgroundColor: '#111', padding: '10px', borderRadius: '8px' }}>
            <div className="episode-thumbnail" style={{ height: '180px' }}>
              <iframe
                width="100%"
                height="100%"
                src={video.link.replace("youtu.be/", "www.youtube.com/embed/")}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ borderRadius: '6px' }}
              ></iframe>
            </div>
            <div className="episode-title" style={{ marginTop: '8px', color: 'white', textAlign: 'center' }}>
              {video.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Zone2;
